import React, { useEffect, useState } from 'react'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Button,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getRequest, postRequest } from "../../../globalhelper/helper";

const AIFinanceAnalyze = () => {
    const [formData, setFormData] = useState({});
    const [Companies, setCompanies] = useState([]);

    const handleChanges = (name, value) => {
        setFormData({ ...formData, [name]: value });
    };

    const handleGstAutomation = () => {
        if (formData.Company) {
            postRequest(`api/veranda/gstAutomation`, formData.Company)
                .then((res) => {
                    console.log("GST Automation Response:", res);
                })
                .catch((error) => console.log(error));
        } else {
            console.log("Please select a company first.");
        }
    };

    useEffect(() => {
        getRequest(`api/edureka/getCompanyAssignedToUser`)
            .then(({ res }) => {
                setCompanies(
                    (res.data || []).sort((a, b) =>
                        (a.orgname || "").localeCompare(b.orgname || ""),
                    ),
                );
                if (res.data.length === 1) {
                    handleChanges("Company", res.data[0]);
                }
            })
            .catch((error) => console.log(error));
        //   var currentDate = moment()
        //   var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
        //   var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
        //   setFrom(firstDay)
        //   setTo(lastDay)
    }, []);
    return (
        <><Accordion defaultExpanded>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <Typography variant="h6">Search Reports</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container gap={2}>
                    <Grid item xs={1} sm={2} md={3}>
                        <Autocomplete
                            size="small"
                            fullWidth
                            value={formData?.Company || null}
                            options={Companies || []}
                            getOptionLabel={(option) => option?.orgname || ""}
                            isOptionEqualToValue={(option, value) =>
                                option?.orgid === value?.orgid
                            }
                            onChange={(event, newValue) =>
                                handleChanges("Company", newValue)
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Company"
                                    variant="outlined"
                                    name="Company"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={1} sm={2} md={3}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleGstAutomation}
                            fullWidth
                        >
                            GST Automation
                        </Button>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion></>
    )
}

export default AIFinanceAnalyze